module.exports = __webpack_public_path__ + "static/media/bassClickyGame.207d0e26.png";